import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, Observable, of, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import {
    TokenValidationResponse,
    TokenValidationService,
} from '../services/token-validation/token-validation.service';
import { ErrorService } from '../services/generic-error/error.service';
import { ErrorPage } from '../services/generic-error/error-page-utils';
import utils from '../utils/account-permission/account-permission.util';

@Injectable({
    providedIn: 'root',
})
export class TokenValidationResolver implements Resolve<TokenValidationResponse> {
    private store = inject(Store);
    private tokenValidationService = inject(TokenValidationService);
    private errorService = inject(ErrorService);


    resolve(route: ActivatedRouteSnapshot): Observable<TokenValidationResponse> {
        const token = route.queryParams['token'] ? route.queryParams['token'] : route.params.token;
        return this.tokenValidationService.tokenValidation(token).pipe(
            tap((data: TokenValidationResponse) =>
                utils.handleAccessTypeAndClientTypeUpdate(data, this.store, this.errorService),
            ),
            catchError((error) => {
                this.errorService.showError(ErrorPage.TECH_DIFF);
                return of(error);
            }),
        );
    }
}
